var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9917 1.66699H7.00832C3.97499 1.66699 2.16666 3.47533 2.16666 6.50866V13.4837C2.16666 16.5253 3.97499 18.3337 7.00832 18.3337H13.9833C17.0167 18.3337 18.825 16.5253 18.825 13.492V6.50866C18.8333 3.47533 17.025 1.66699 13.9917 1.66699Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 4.75833C16.0083 4.60833 15.8917 4.48333 15.7333 4.41667C15.6583 4.39167 15.5833 4.375 15.5 4.375H12.1667C11.825 4.375 11.5417 4.65833 11.5417 5C11.5417 5.34167 11.825 5.625 12.1667 5.625H13.9917L6.125 13.4917V11.6667C6.125 11.325 5.84167 11.0417 5.5 11.0417C5.15833 11.0417 4.875 11.325 4.875 11.6667V15C4.875 15.0833 4.89167 15.1583 4.925 15.2417C4.99167 15.3917 5.10833 15.5167 5.26667 15.5833C5.33333 15.6083 5.41667 15.625 5.5 15.625H8.83333C9.175 15.625 9.45833 15.3417 9.45833 15C9.45833 14.6583 9.175 14.375 8.83333 14.375H7.00833L14.875 6.50833V8.33333C14.875 8.675 15.1583 8.95833 15.5 8.95833C15.8417 8.95833 16.125 8.675 16.125 8.33333V5C16.125 4.91667 16.1083 4.84167 16.075 4.75833Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon03);
export default __webpack_public_path__ + "static/media/call-icon-03.42ba0e97313db7c0e4c1b4336a69f397.svg";
export { ForwardRef as ReactComponent };